export default {
  banner: {
    // title: "加入 Authing，遇到更优秀的你",
    // subtitle: "成为世界一流的计算机科学、身份安全、数据和企业管理专家团队中的一员",
    title: "工作在 Authing",
    subtitle:
      "成为世界一流的计算机科学、身份安全、数据和企业管理专家团队中的一员",
  },
  comment: {
    title: "团队心中的 Authing",
  },
  salary: {
    title: "成长在 Authing",
    item1: {
      title: "薪资和年终奖",
      subtitle:
        "Authing 提供媲美大厂的薪资以及可观的年终奖金，我们希望每一位成员都能在实现个人价值的同时获得丰厚的待遇",
    },
    item2: {
      title: "股票期权",
      subtitle:
        "Authing 预留了丰富的期权股票，我们希望每一位成员和公司共同成长",
    },
    item3: {
      title: "弹性工作",
      subtitle:
        "Authing 坚决不打卡，永远坚持结果导向，我们希望每一位成员的创造力都不被制度框住",
    },
    item4: {
      title: "下午茶和零食铺",
      subtitle: "Authing 每天都有免费的下午茶，零食铺无限量供应零食",
    },
    item5: {
      title: "关注健康",
      subtitle:
        "Authing 免费提供全面的健康体检，我们希望每一位成员都保持健康的身体",
    },
    item6: {
      title: "团队建设",
      subtitle:
        "Authing 定期团建，每月举办 Birthday Party，我们希望每一位成员 work hard, play hard",
    },
  },
  jobs: {
    title: "我们的职位",
    subtitle:
      '简历请投递至：lewisli@authing.cn，邮件标题为“招聘-岗位名称-姓名"',
    select: {
      "city-all": "全部",
      "city-beijing": "北京",
      "city-shanghai": "上海",
      "city-shenzhen": "深圳",
      "type-all": "全部",
      "type-product": "产研类",
      "type-business": "商业化",
      "type-other": "其他",
    },
    "button-apply": "立即申请",
    job1: {
      title: "安全负责人",
      experience: "经验 3-5 年 / 本科",
      salary: "40-60k·15 薪",
      description: {
        item1: "负责安全与风控核心产品的架构、设计与实现，提供稳定可靠的服务；",
        item2: "跟踪数据安全、端安全、反作弊等技术的最新进展并应用于实践；",
        item3:
          "负责技术攻关和创新技术引用，解决产品开发过程中的高性能，高并发和高可靠性问题；",
        item4: "调研公司研发体系和流程，给出相应底层服务的平台设计和技术方案；",
        item5:
          "将设计方案实现为具体的平台功能，持续跟踪结果、不断优化用户体验；",
      },
      skills: {
        item1: "5 年以上服务端开发经验，对 Unix/Linux 有深入了解；",
        item2:
          "出色的编码能力，熟练使用 Java 或 Golang ，熟悉常用的算法，熟悉开源框架，解决问题能力强；",
        item3: "对后端程序性能优化有丰富经验；",
        item4: "掌握 Redis、MongoDB、MySQL等存储系统原来及应用；",
        item5: "对分布式计算，分布式存储的架构设计理念和动机有一定理解；",
        item6: "网络安全或计算机相关专业优先，具备安全相关项目经验优先；",
        item7:
          "加分项：在头部互联网公司参与过安全或风控产品的开发建设；有大规模后端服务的设计和开发方面经验。",
      },
    },
    job2: {
      title: "DevOps 负责人",
      experience: "经验 3-5 年 / 本科",
      salary: "40-60k·15 薪",
      description: {
        item1: "负责自动化运维平台、DevOps 体系的搭建和维护；",
        item2:
          "负责研发生命周期的工具和系统，如持续集成、代码发布、容量规划、监控等。",
      },
      skills: {
        item1: "熟悉至少一门开发语言，并具有完整的项目开发经验；",
        item2:
          "熟悉云原生体系架构，熟悉 AWS，阿里云，腾讯云等共有云平台。熟悉 Terraform 编排工具；",
        item3: "熟悉 Kubernetes 技术及其原理，有过深度 Kubernetes 实践经验；",
        item4:
          "熟悉自动化运维管理工具（puppet/saltstack/ansible），厌恶手工操作；",
        item5:
          "熟练使用日志处理及分析相关经验，熟悉相关的组件，如：kafka，elk，flume，hive，storm等；",
        item6: "具有持续集成、持续交付和自动化发布的经验；",
        item7: "学习能力强，工作积极主动，勤奋认真踏实；",
        item8: "良好的工作抗压能力和跨团队协作协调能力，有服务意识；",
        item9: "参与客户对接；",
        item10:
          "加分项：参与过完整的运维体系建立；有以下相关经验：资产管理平台。",
      },
    },
    job3: {
      title: "产品总监",
      experience: "经验 3-5 年 / 本科",
      salary: "40-60k·15 薪",
      description: {
        item1:
          "根据公司战略需要，分析、跟踪与引领国内外 IDaaS、身份云相关产业与市场的形势与标准，展开多个产品线的中长期规划与版本计划；",
        item2:
          "管理产品团队，制定完善部门规范与组织结构，持续优化提升团队能力，建设人才梯队；",
        item3:
          "带领团队在计划时间完成产品市场需求分析和应用场景分析，组织市场调研，深入理解提升用户体验的机会点，定义产品解决方案和执行计划；",
        item4:
          "组织产品经理，配合项目实施，跟进产品需求与缺陷，支持项目交付与产品持续发展；",
        item5:
          "围绕各产品线与相应市场展开运营，建立良好的用户反馈，完善产品与社区。",
      },
      skills: {
        item1: "211 高校统招本科及以上学历；",
        item2:
          "具备优秀的产品规划能力和方法论，能够对现有业务产品进行创新和变革；",
        item3: `5 年以上的产品经理经验，有丰富的 2B 与 2C 方向产业分析、产品规划、产品与社区运营、项目
          支持、商业协作经验；`,
        item4:
          "对用户体验、痛点及难点有追求，有较强的逻辑能力和优秀的文案功底；",
        item5: "在成功的大型 2B/2C 产品中担任主产品经理的角色；",
        item6: "有强烈的好奇心，以及良好的分析能力、执行力与沟通能力；",
        item7: "有技术背景，对云计算相关技术与开源软件有较好的了解；",
        item8: "加分项：有计算机软件行业经验。",
      },
    },
    job4: {
      title: "内容运营",
      experience: "经验 3-5 年 / 本科",
      salary: "30-50k·15 薪",
      description: {
        item1:
          "围绕 Authing 技术产品，结合用户需求，进行相关内容的开发制作，如产品解读、行业解决方案、客户案例包装、行业趋势、数据报告、数字化转型等深度内容的产出和传播，增加百度收录和技术社区 Authing 文章的转载量，激发用户对 Authing 的了解兴趣，降低学习成本，增进开发者、CIO/CTO 等技术用户群体对 Authing 的了解和认可，推动用户增长与活跃；",
        item2:
          "结合产品内容进行全流程包装，完成公司产品内容在技术群体中的推广，构建内容传播策略，对内容质量、阅读、传播、促活效果负责；",
        item3:
          "配合 SEO/SEM 团队进行官网内容的策划和编辑，为官网、技术社区提供品牌、行业、产品的关键内容输出；",
        item4:
          "发掘和梳理内容玩法，根据产品的迭代情况和市场热点，独立进行选题策划，通过运营手段引导用户，塑造品牌口碑；",
        item5:
          "负责内容传播后的数据整理、分析、复盘，用营销数据结果引导产品、内容优化方向及运营策略。",
      },
      skills: {
        item1: "本科以上学历，擅长内容运营、网络传播相关的运营方案设计；",
        item2:
          "懂商业、懂技术、对 toB / SaaS 行业了解，有热情、耐性，有技术社区运营经验优先；",
        item3: "有 toB 内容运营的 sense，有 CTA（call to action） 经验；",
        item4:
          "有门户网站/科创媒体/技术社区的记者、编辑经验优先，沟通能力强，能承受工作压力，愿与创业公司共同成长；",
        item5:
          "能通过内容传播数据进行有效性分析，通过数据驱动解决问题，擅长精细化运营，目标明确，营销结果导向；",
        item6:
          "加分项：5 年以上工作经验，新闻/广告/营销/计算机相关专业毕业加分，在开源中国、Segmentfault、InfoQ等技术社区内容运营经验或 36 氪、甲子光年、虎嗅等科创类媒体记者、编辑经验、爱分析、艾瑞、IDG等分析机构分析师经验或有咨询工作经验的优先。",
      },
    },
    job5: {
      title: "CSM 总监",
      experience: "经验 3-5 年 / 本科",
      salary: "40-60k·15 薪",
      description: {
        item1:
          "负责客户关系维护，维持客户高满意度，践行客户第一的原则，协调公司资源，满足客户合理需求，协助客户解决使用中各种情况；",
        item2:
          "负责产品落地交付和培训实施，协助客户调整制度和流程，结合客户需求，定期为客户提供数据分析，汇报客户使用情况，为客户提供优化方案；",
        item3: "培训客户成功经理理解新产品和新服务的落地；",
        item4:
          "提炼客户的需求，了解产品原理，推销新的模块/新的服务，寻求客户成功的新的增长点；",
        item5:
          "完成续约率指标及消费场景拓展任务，提升客户活跃度及拉升公司整体营收。",
      },
      skills: {
        item1:
          "具有客户成功/顾问岗位工作经验，曾在 SaaS 行业，互联网行业等任职经验优先；",
        item2: "本科及以上学历，有软件研发背景经验优先；",
        item3: "工作认真、细致，责任心强，具有团队意识和抗压能力；",
        item4: "能够就客户的某个问题进行业务侧的深入了解，不仅限于技术问题；",
        item5: "有较强的文档能力，针对身份领域问题，能够形成文字性解决方案；",
        item6: "可以发现客户的相关问题并能抽象到一定层面探索新的方向的能力。",
      },
    },
    job6: {
      title: "Tiger Force- KA",
      experience: "经验 3-5 年 / 本科",
      salary: "面议",
      description: {
        item1: "负责 Authing 安全云产品重要客户的销售工作；",
        item2:
          "梳理目标市场销售机会，主动挖掘商机，树立标杆客户，形成可复制销售模式；",
        item3: "定期拜访合作伙伴和客户，维护与合作伙伴和客户的良好的业务关系；",
        item4:
          "及时更新公司产品信息，充分了解客户需求并积极跟进，制定合理方案，推进商务谈判、签约。",
      },
      skills: {
        item1: "本科及以上学历，计算机、通信、市场营销或其它相关专业；",
        item2:
          "具有 5 年以上  to B  销售经验，有VPN或其他网络安全产品、云产品销售经验者或者同行业渠道销售经验者优先；",
        item3:
          "具有良好的关系建立能力、出色的协调能力，良好的团队合作精神，能承受较高工作压力，上进心强，可适应短期出差；",
        item4: "具有互联网企业、央企、金融、制造业等行业客户资源者优先。",
      },
    },
    job7: {
      title: "Tiger Force - SA",
      experience: "经验 3-5 年 / 本科",
      salary: "面议",
      description: {
        item1:
          "以 KA 客户突破为目标，洞察客户的需求，基于客户需求，设计和开发配套方案及销售工具； ",
        item2: "主导负责的 KA 客户的技术交流，完成方案和产品的认可工作；",
        item3: "牵引研发规划，参与  KA  客户需求的分析，帮助产品的设计和改进；",
        item4: "对应客户端相关的所有售前技术工作。 ",
      },
      skills: {
        item1:
          "对行业 IT 信息化建设比较熟悉，从事3-5年以上相关行业的厂商售前、甲方；",
        item2:
          "网络安全、云计算，至少对一个方向的技术方案较为精通，了解相关产品及主流技术；",
        item3:
          "有一定的顶层设计能力和解决方案撰写能力，曾主导过对应行业的重大项目的解决方案设计。",
      },
    },
    job8: {
      title: "前端开发工程师",
      experience: "经验 3-5 年 / 本科",
      salary: "20-40k·15 薪",
      description: {
        item1:
          "参与公司对外产品的前后端基础架构的设计与实现，提供稳定可靠的服务；",
        item2: "负责内部平台的前后端架构设计与实现；",
        item3:
          "负责技术攻关和创新技术引用，解决产品开发过程中的高性能，高并发和高可靠性问题；",
        item4: "调研公司研发体系和流程，给出相应底层服务的平台设计和技术方案。",
      },
      skills: {
        item1:
          "精通HTML5、CSS3、JavaScript，计算机基础扎实，熟悉数据结构、网络等；",
        item2: "对至少一种 MV* 框架（例如 React 或 Vue 等）有深入的研究；",
        item3: "了解后端技术栈，熟悉后端语言 Node.js ，熟悉与后端的协作模式；",
        item4:
          "对用户体验、交互及用户需求分析等有一定了解，有产品或界面设计经验者优先；",
        item5:
          "对云计算、IDaaS 或开发者相关的产品有认知、有实践经验者优先，熟悉 Serverless、FaaS、DevOps 相关技术者优先；",
        item6:
          "有较高的技术热情和积极性者，有良好的沟通能力，能承受较强的工作压力，具有团队合作精神，能够站在用户的角度去理解问题，发掘不足，善于总结；",
        item7: "加分项：参与或主导过优秀的开源项目；有优秀的技术博文、博客。",
      },
    },
    job9: {
      title: "后端开发工程师",
      experience: "经验 3-5 年 / 本科",
      salary: "20-40k·15 薪",
      description: {
        item1:
          "参与公司对外产品的前后端基础架构的设计与实现，提供稳定可靠的服务；",
        item2: "负责内部平台的前后端架构设计与实现；",
        item3:
          "负责技术攻关和创新技术引用，解决产品开发过程中的高性能，高并发和高可靠性问题；",
        item4: "调研公司研发体系和流程，给出相应底层服务的平台设计和技术方案；",
        item5:
          "将设计方案实现为具体的平台功能，持续跟踪结果、不断优化用户体验；",
        item6:
          "参与设计平台数据结构和系统架构，通过 Node.js 实现平台中的部分服务；",
        item7: "负责公司客户交付项目的架构设计和实现。",
      },
      skills: {
        item1: "3 年以上互联网开发经验，对 Unix/Linux 有深入了解；",
        item2:
          "出色的编码能力，精通 Node.js，熟悉常用的算法，熟悉开源框架，解决问题能力强；",
        item3: "熟练掌握前端框架 React/VUE，熟悉前端工程化及组件化开发模式；",
        item4: "对后端程序性能优化有丰富经验；",
        item5: "掌握 Redis、MongoDB、MySQL 等存储系统原理及应用；",
        item6: "对分布式计算，分布式存储的架构设计理念和动机有一定理解；",
        item7: "对 HTTP 协议有深刻的理解，熟悉 TCP/IP 等网络协议；",
        item8:
          "加分项：有 Python、Go、PHP 开发经验；参与或拥有开源项目，为开源社区贡献过代码；有大规模后端服务的设计和开发方面经验。",
      },
    },
    job10: {
      title: "测试工程师",
      experience: "经验 3-5 年 / 本科",
      salary: "20-40k·15 薪",
      description: {
        item1:
          "根据产品需求和测试计划设计测试用例，执行测试用例，熟练运用 bug 管理工具提交和跟踪；",
        item2: "完成产品的集成测试、系统测试，对产品的接口、功能等全面测试；",
        item3: "根据测试过程编写相关测试报告、配合研发人员进行功能调试；",
        item4:
          "作为业务与产品研发的中枢接口，接收、分析业务需求问题并推进产品与研发的完善；",
        item5: "负责引入和完善新的测试方法提高测试效率；",
        item6: "负责建立质量度量标准驱动产品质量提升。",
      },
      skills: {
        item1: "3 年以上 QA 工作经验，熟悉 Web 测试；",
        item2: "熟悉移动端自动化测试框架、自动化用例编写，并能对框架进行优化；",
        item3: "熟悉 Android/iOS 平台特性，有一定的编程能力，熟悉 Java 语言；",
        item4: "熟悉 HTTP 协议、RESTful API 及互联网应用工作原理；",
        item5: "对敏捷开发及 CI/CD 有一定了解；",
        item6: "有良好的沟通协作及解决问题能力，良好的执行力及推动力；",
        item7: "能够带领团队为公司做好产品最后一道防线。",
      },
    },
    job11: {
      title: "MDR",
      experience: "经验 3-5 年 / 本科",
      salary: "面议",
      description: {
        item1:
          "熟练掌握公司产品知识及所需的业务技能，采用电话形式与目标客户进行沟通，接听客户来电，清晰来自各渠道的原始线索，并根据特定的标准进行分类、分级，了解客户需求，预算等情况，匹配相应的产品和解决方案，寻找销售合作机会；",
        item2:
          "负责承接、完善、整理市场活动、网站等渠道获得客户信息和商机，进行甄别后把 MQL （Marketing Qualified Leads）转化成销售线索，并邀约上门，配合销售共同推进签约赢单；",
        item3:
          "通过电话、邮件、微渠道（脉脉、领英、探迹）等各类营销技术工具主动触达陌生客户，与符合客户画像的关键 KP 进行有效沟通，传递产品价值，激发客户兴趣并邀约成功；",
        item4:
          "通过内容、活动和社群等首都持续孵化潜客，能通过沟通交流快速精准找到 KP （关键决策人），为销售输出高质量的线索；",
        item5:
          "将网络线索及市场活动获取的线索进行初步筛选，在线索不够时能通过电话拓展输出有效线索；",
        item6:
          "分析客户需求，总结市场、行业特征及规律，为增长、销售部门提出建设性的市场拓展方案；",
        item7: "完成领导委派的临时性工作。",
      },
      skills: {
        item1:
          "统招大专以上学历，具备 2B 销售、电话销售、客服、外呼、客户前期开拓、客户孵化和培育等相关工作经验 2 年以上的优先考虑；",
        item2: "有过创业公司工作/toB SaaS 行业背景者，优先考虑；",
        item3:
          "不抵触打电话，谈吐自然，抗压能力强，不玻璃心，皮实、沟通能力强；",
        item4:
          "思维逻辑清晰，声音条件好（普通话标准、吐字清晰，亲切，有磁性），抗压能力强，敢于接高薪挑战；",
        item5: "沟通表达、理解能力良好，能快速协助客户。",
      },
    },
    job12: {
      title: "SDR",
      experience: "经验 3-5 年 / 本科",
      salary: "面议",
      description: {
        item1: "快速学习公司的产品和业务，明确客户群体开发方向，制定开发计划；",
        item2:
          "电话外呼为主，通过多种方式触达目标客户，包括但不限于外呼list、脉脉、领英、展会等形式，建立有效联系，产出销售线索；",
        item3:
          "线索转化为有效商机后分配给销售团队，与销售同步具体信息，协助完成客户后续的拜访和跟进；",
        item4:
          "建立详细的客户档案和拓展记录，持续优化拓展策略，提升线索到商机的转化；",
        item5:
          "按季度、月度考核行为指标和业绩指标，同时提供行为和业绩双重绩效激励。",
      },
      skills: {
        item1:
          "大专以上学历，两年以上电话销售工作经验，或一年以上toB软件销售经验（saas 类产品优先）；",
        item2: "具备合格 Coldcall 的销售能力；",
        item3: "拥有敏锐的客户/市场“嗅觉”，较强的自我时间管理意识；",
        item4: "为人正直、勤奋踏实，皮实抗压能力强。",
      },
    },
    job13: {
      title: "产品经理（交付）",
      experience: "经验 3-5 年 / 本科",
      salary: "15-30k·15 薪",
      description: {
        item1: "作为项目的负责人，负责大客户的实施与交付项目的管理工作；",
        item2:
          "梳理客户组织架构、决策流程、数据能力现状，制定对应的交付策略，带领团队成员与客户一起落地；",
        item3:
          "持续推进 Authing 产品在客户侧的使用深度和广度，发现客户的业务诉求与合作机会，与项目成员一起为客户提供有效的数据解决方案；",
        item4: "在项目的售前阶段参与评审，规避合同风险，确保项目能成功交付。",
      },
      skills: {
        item1: "本科及以上学历，计算机，金融，统计，数学类专业优先；",
        item2:
          "具有 ToB 企业服务经验，熟练掌握项目管理工作及方法，2 年以上实际项目管理经验；",
        item3:
          "有行业标杆企业、知名外企咨询公司任职经验，熟悉产品迭代、用户运营等业务场景；",
        item4: "具备良好的抗压能力、沟通能力和团队协作精神；",
        item5:
          "有 IAM/IDaaS/安全/云计算交付项目背景，有数据驱动业务发展经验者优先；",
        item6: "学习能力快；主动性强。",
      },
    },
    job14: {
      title: "产品经理（B 端）",
      experience: "经验 5 年以上 / 本科",
      salary: "30-40k·15 薪",
      description: {
        item1:
          "负责产品的设计工作，包含产品架构及平台体系搭建，并能对产品模式进行创新；",
        item2:
          "研究市场需求和使用场景，通过需求调研、功能设计、策略制定、效果提升等构建标准化产品解决方案；",
        item3:
          "收集和分析市场及竞对信息，进行产品规划，并能进行产品的全面效果评估；",
        item4:
          "与团队配合完成产品的立项评审、计划、协调沟通、跟踪推进、保证产品迭代输出；",
        item5: "高效协同市场、研发、运营团队，共同达成目标；",
        item6: "负责产品增长功能迭代；",
        item7: "负责产品品牌建设。",
      },
      skills: {
        item1: "有商业化产品经验，有从 0 到 1 搭建商业化体系者优先；",
        item2:
          "良好的技术能力，有 1 年以上软件研发经验，云计算、IAM、IDaaS 相关工作经验者优先；",
        item3: "熟悉整个商业化链条，了解主流平台商业化模式和产品设计方法；",
        item4: "参与过产品从 0 到 1 阶段；",
        item5: "可以独当一面；",
        item6:
          "具备良好的沟通协调能力，能很好的和不同团队成员进行合作并承担较大的压力。",
      },
    },
    job15: {
      title: "UI 设计师",
      experience: "经验 3-5 年 / 本科",
      salary: "15-30k·15 薪",
      description: {
        item1: "负责PC界面设计及交互设计；",
        item2:
          "参与产品需求及设计评审，提供可行性的设计解决方案，对交互和UI设计有深入研究和理解；",
        item3: "负责项目的设计评审、品质把控，推动设计创新，总结设计方法论；",
        item4:
          "跟踪方案的落地及上线，跟进研发过程和最终产品的设计验收，确保设计还原质量。",
      },
      skills: {
        item1:
          "本科及以上学历，设计类相关专业，2 年以上互联网（B端）设计经验；",
        item2:
          "具有严谨的逻辑思考能力，可以快速理解产品及分解设计需求，独立完成设计需求；",
        item3:
          "有良好的审美、敏锐的设计洞察力及前瞻的设计理念，具有沟通合作意识及良好的协调组织能力。",
      },
    },
    job16: {
      title: "销售运营",
      experience: "经验 3-5 年 / 本科",
      salary: "面议",
      description: {
        item1:
          "根据部门整体销售目标，对销售业绩进度进行跟踪以及运营分析，并给出业务指导建议；",
        item2:
          "负责完善销售流程，对过程跟进管理，各项销售管理制度以及流程推进落地;",
        item3:
          "销售管理过程中跨业务线及部门的协作沟通，保障各项工作有序、高效地运行；",
        item4:
          "结合不同业务阶段以及各项目的业务实际情况，制定销售策略并执行落地，跟踪和调整活动进度，及时调整策略，完成复盘和持续优化；",
        item5: "完成各项销售运营工作的拆解和目标制定，搭建并管理销售运营团队；",
        item6:
          "熟悉CRM系统，及财务数据分析，能及时根据业务发展帮助公司在crm系统提出更多合理建议及优化。",
      },
      skills: {
        item1: "有销售运营相关经验优先、5年以上相关工作经验；",
        item2: "思维敏捷，有良好的分析能力和问题解决能力，能积极推动业务发展；",
        item3:
          "良好的跨部门沟通协作能力、 自我驱动能力、组织能力，能够主动及紧盯销售进度；",
        item4: "熟悉 saas 或者 to B业务 ，能快速配合公司管理层了解业务方向；",
        item5:
          "相关财务经验，熟悉掌握数字运营需要使用多维度工具；提供数字维度的风险预测；",
        item6: "英文较好，读写熟练。",
      },
    },
    job17: {
      title: "实施工程师",
      experience: "经验 3-5 年 / 本科",
      salary: "面议",
      description: {
        item1:
          "负责为高意向客户进行 PoC（概念验证）或 Demo 搭建，并协助销售和售前推进项目；",
        item2: "负责为已签单客户进行项目交付和实施，确保项目顺利完成目标；",
        item3:
          "负责支持和维护已实施 Authing 软件解决方案的客户，及时响应客户的技术问题；",
        item4: "熟练使用 Authing 的 API/SDK，并为客户解决技术问题。",
      },
      skills: {
        item1: "熟练掌握软件开发基础知识和通用体系结构；",
        item2: "具备 HTTP 知识，加密和基本安全概念；",
        item3: "精通至少一种编程语言，最好是 Node.js、Java；",
        item4: "2 年及以上的技术支持或软件开发经验；",
        item5: "了解身份验证和权限概念（加分项）；",
        item6:
          "了解至少一种身份认证协议：OAuth2，OIDC，SAML，WS-FED，LDAP，Azure AD 等（加分项）。",
      },
    },
    job18: {
      title: "售前支持工程师",
      experience: "经验 3-5 年 / 本科",
      salary: "面议",
      description: {
        item1:
          "负责配合部门完成项目线索跟踪、需求分析、建设规划、技术方案以及招投标等工作；",
        item2: "负责售前交接工作，使项目顺利进入 PoC 或售后实施阶段；",
        item3:
          "负责行业知识、技能等沉淀工作，进行解决方案、案例等售前资料库的完善和更新。",
      },
      skills: {
        item1: "具备至少 2 年以上一线研发岗位的经验；",
        item2: "具备 3 年及以上的售前工程经验，并负责过大型项目的整体流程；",
        item3: "具备业务需求分析能力、语言表达、逻辑思维和文字组织能力；",
        item4:
          "具备独立撰写演示文档、技术及服务方案、项目投标书、项目建议方案能力；",
        item5: "具备在复杂解决方案环境中进行技术实施的经验；",
        item6: "具有时间管理，项目管理技能，以及多部门协作能力。",
      },
    },
    job19: {
      title: "商业化-KA",
      experience: "经验 3-5 年 / 本科",
      salary: "面议",
      description: {
        item1: "熟悉公司身份云产品所在行业及市场信息，学习并熟练掌握公司产品；",
        item2:
          "通过合作伙伴、会议等方式发掘潜在客户，开拓新市场，负责销售目标分解和承担销售指标达成；",
        item3:
          "引导客户需求分析并积极跟进、立项申请、解决方案打造、商务谈判、招投标等；",
        item4:
          "与售前部门配合协调，高效成单，及项目应收款跟进，按时完成销售回款指标；",
        item5: "制定每天、每周、每月的销售计划，并反馈销售结果；",
        item6: "协助调研分析竞品，保证 Authing 快速迭代。",
      },
      skills: {
        item1:
          "本科及以上学历，计算机、通信、软件等专业，对软件、网络、云等IT领域有基本了解；",
        item2: "具有 5 年以上 To B 的软件销售经验，熟悉 SaaS 市场优先考虑；",
        item3:
          "具备较强的商务拓展能力、沟通协调能力、谈判能力，有敏锐的市场洞察力和创新能力；",
        item4:
          "具有极强的目标感、执行力，善于自我激励，注重承诺，具有较强的抗压能力；",
        item5:
          "具有身份、信息安全、云计算、IDaaS 或  IT 开发人员对接相关的经验者优先；",
        item6:
          "负责大客户的开拓工作，包含金融、新零售、制造、高科技、互联网、政府等行业，如有必要，需要出差。",
      },
    },
  },
  "job-detail": {
    publishtimer: "发布时间",
    "label-description": "职位描述",
    "label-skills": "职位要求",
    "label-newjob": "最新职位",
    "button-apply": "现在申请",
    navbar: {
      nav0: "关于 Authing ",
      nav1: "加入我们",
      nav2: "Node.js 研发工程师",
    },
  },
};
